<script>
import * as types from '@/store/mutationTypes';
import AppPage from '@/components/core/AppPage';

export default {
    name: 'Base',

    components: {
        AppPage
    },

    data() {
        return {
            loading: false
        };
    },

    methods: {
        openDialog(ref) {
            this.$refs[ref].open();
        },

        closeDialog(ref) {
            this.$refs[ref].close();
        },

        showSnackBar(text) {
            this.$store.commit(types.APPEARANCE_SET_SNACKBAR_TEXT, text);
        },

        showSuccessAlert(message) {
            this.$store.commit(types.APPEARANCE_SET_ALERT, { type: 'success', message });
        },

        showInfoAlert(message) {
            this.$store.commit(types.APPEARANCE_SET_ALERT, { type: 'info', message });
        },

        showWarningAlert(message) {
            this.$store.commit(types.APPEARANCE_SET_ALERT, { type: 'warning', message });
        },

        showErrorAlert(message) {
            this.$store.commit(types.APPEARANCE_SET_ALERT, { type: 'error', message });
        },

        showAlert(type, message) {
            this.$store.commit(types.APPEARANCE_SET_ALERT, { type, message });
        },

        setLoading(value) {
            this.loading = value;
            if (value) {
                this.$store.commit(types.APPEARANCE_SET_PROGRESS_CURSOR);
            } else {
                this.$store.commit(types.APPEARANCE_SET_DEFAULT_CURSOR);
            }
        },

        isLoading() {
            return this.loading;
        },

        setViewTitle(title) {
            this.$store.commit(types.APPEARANCE_SET_VIEW_TITLE, title);
        },

        clear() {
            this.setLoading(false);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/views/Base.vue